<script>
  import { onMount } from "svelte";
  import "@simonwep/pickr/dist/themes/monolith.min.css";
  import Pickr from "@simonwep/pickr";

  export let title;
  export let color = "#000000";

  let pickrElm;
  let pickr;

  onMount(() => {
    pickr = Pickr.create({
      el: pickrElm,
      theme: "monolith",
      default: color,
      useAsButton: true,
      swatches: [
        "rgba(244, 67, 54, 1)",
        "rgba(233, 30, 99, 1)",
        "rgba(156, 39, 176, 1)",
        "rgba(103, 58, 183, 1)",
        "rgba(63, 81, 181, 1)",
        "rgba(33, 150, 243, 1)",
        "rgba(3, 169, 244, 1)",
        "rgba(0, 188, 212, 1)",
        "rgba(0, 150, 136, 1)",
        "rgba(76, 175, 80, 1)",
        "rgba(139, 195, 74, 1)",
        "rgba(205, 220, 57, 1)",
        "rgba(255, 235, 59, 1)",
        "rgba(255, 193, 7, 1)"
      ],

      defaultRepresentation: "HEX",
      components: {
        preview: true,
        opacity: true,
        hue: true,

        interaction: {
          hex: false,
          rgba: false,
          hsva: false
        }
      }
    });

    pickr.on("change", hsva => {
      if (hsva) {
        color = hsva.toHEXA().toString();
      }
    });
    pickr.on("show", () => pickr.setColor(color));
  });
</script>

<style>
  .button {
    display: flex;
    height: 100%;
    color: #333;
    font-weight: 500;
  }
  input {
    border-color: #dbdbdb;
  }
</style>

<div class="field">
  <div class="field-body">
    <div class="field has-addons">

      <div class="control">
        <div class="button is-static">{title}</div>
      </div>

      <div class="control has-icons-right" bind:this={pickrElm}>
        <input class="input is-small" type="text" bind:value={color} />
        <span class="icon is-small is-right">
          <i class="fas fa-tint" style="color: {color}" />
        </span>
      </div>

    </div>
  </div>
</div>
